import {
  SET_GLOBAL_START_DATE,
  SET_GLOBAL_END_DATE,
  RESET_GLOBAL_START_DATE,
  RESET_GLOBAL_END_DATE,
} from '../actions/types/GlobalPeriodSelectionTypes';
import { AUTH_LOGOUT } from '../../../../redux/actions/types/authActionTypes';

const initialState = {
  globalStartDate: new Date().toDateString(),
  globalEndDate: new Date().toDateString(),
};

export default (state = initialState, action) => {
  switch (action.type) {
  case SET_GLOBAL_START_DATE:
    return {
      ...state,
      globalStartDate: action.payload.globalStartDate,
    };
  case SET_GLOBAL_END_DATE:
    return {
      ...state,
      globalEndDate: action.payload.globalEndDate,
    };
  case RESET_GLOBAL_START_DATE:
    return {
      ...state,
      globalStartDate: initialState.globalStartDate,
    };
  case RESET_GLOBAL_END_DATE:
    return {
      ...state,
      globalEndDate: initialState.globalEndDate,
    };
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};
